export const EShapeTextDirection = wcardinal.ui.EShapeTextDirection;